import { vrocManager, vrocFactory, VROCComponentFactory } from '../../_VROC/VROCComponentFactory.js';

export class Excursions {
	constructor() {
		this.activeComponent = null; // Активный компонент (если есть)
		this._debounceTimer = null; // Таймер для debounce
		this.orderId = this._getOrderId(); // Получаем ID заказа один раз
		this._registerComponent();
		this._setupFormSubmitHandler();
		this.setupFilters();
	}

	/**
	 * Регистрирует базовую конфигурацию компонента в менеджере
	 */
	_registerComponent() {
		const baseConfig = {
			template: 'mod_crm/excursions_content',
			node: '.excursions__content',
			attach: true, // Режим attach - контент уже есть на странице
			moduleId: 20,
            params: {
                action: 'loadItems', // Начальный запрос для загрузки данных
				...(this.orderId && { orderId: this.orderId }) // Добавляем orderId если он есть
			},
			// Автоматически генерируемые действия
			autoActions: {
				updateExcursionsList: {
					successMessage: 'Список экскурсий обновлен',
					errorMessage: 'Ошибка при обновлении списка экскурсий'
				}
			},
			// Валидация данных
			validation: {
				updateExcursionsList: {
					// Здесь можно добавить валидацию параметров фильтрации
				}
			},
			// Обработка ошибок
			onError: (message, error) => {
				console.error('Excursions error:', message, error);
			},
			// События жизненного цикла
			events: VROCComponentFactory.createEvents({
				beforeInit: () => {
					console.log('Excursions: Initialization started');
				},
				afterInit: () => {
					console.log('Excursions: Initialization completed');
				},
				beforeAction: (data) => {
					console.log('Excursions: Action started', data.action);
				},
				afterAction: (data) => {
					console.log('Excursions: Action completed', data.action);
				},
				error: (data) => {
					console.error('Excursions: Error occurred', data.message);
				}
			}),
			// Настройки уведомлений
			notifications: {
				show: (message, type) => {
					console.log(`[${type.toUpperCase()}] ${message}`);
				}
			}
		};

		// Регистрируем базовую конфигурацию в менеджере
		vrocManager.registerComponent('excursions', baseConfig);
	}

	/**
	 * Настраивает обработчик изменений формы фильтров
	 */
	_setupFormSubmitHandler() {
		const form = document.querySelector('.excursions__control');
		if (form) {
			// Обрабатываем все изменения в полях формы, исключая только селект для добавления детей
			const inputs = form.querySelectorAll('input, select, textarea');
			inputs.forEach(input => {
				// Пропускаем только селект для добавления детей
				if (!input.classList.contains('guests-picker__kids-item-select')) {
				input.addEventListener('change', (event) => {
					this._handleFormChange(event);
				});
					// Для текстовых полей также обрабатываем input
					if (input.type === 'text' || input.type === 'number' || input.tagName === 'TEXTAREA') {
						input.addEventListener('input', (event) => {
							// Добавляем debounce для текстовых полей
							clearTimeout(this._debounceTimer);
							this._debounceTimer = setTimeout(() => {
								this._handleFormChange(event);
							}, 500);
						});
					}
				}
			});

			// Настраиваем guests-picker
			this._setupGuestsPicker();

			// Настраиваем datepicker
			this._setupDatePicker();

		// Также обрабатываем сабмит формы
		form.addEventListener('submit', (event) => {
			event.preventDefault();
			this._handleFormChange(event);
		});
		}
	}

	/**
	 * Настраивает guests-picker
	 */
	_setupGuestsPicker() {
		const guestsPicker = document.querySelector('.guests-picker');
		if (!guestsPicker) return;

		// Обработчики для кнопок плюс/минус взрослых
		const adultsMinus = guestsPicker.querySelector('.guests-picker__adults-minus');
		const adultsPlus = guestsPicker.querySelector('.guests-picker__adults-plus');
		const adultsInput = guestsPicker.querySelector('.guests-picker__adults-input');

		if (adultsMinus && adultsPlus && adultsInput) {
			adultsMinus.addEventListener('click', () => {
				const currentValue = parseInt(adultsInput.value) || 0;
				if (currentValue > 0) {
					adultsInput.value = currentValue - 1;
					this._handleFormChange({ target: adultsInput });
				}
			});

			adultsPlus.addEventListener('click', () => {
				const currentValue = parseInt(adultsInput.value) || 0;
				adultsInput.value = currentValue + 1;
				this._handleFormChange({ target: adultsInput });
			});

			adultsInput.addEventListener('change', () => {
				this._handleFormChange({ target: adultsInput });
			});
		}

		// Обработчик для селекта детей (только для внутренней логики, без отправки формы)
		const kidsSelect = guestsPicker.querySelector('.guests-picker__kids-item-select');
		if (kidsSelect) {
			// НЕ добавляем обработчик - селект только для добавления, не для отправки
		}

		// Обработчик кнопки "Готово"
		const readyBtn = guestsPicker.querySelector('.guests-picker__ready');
		if (readyBtn) {
			readyBtn.addEventListener('click', () => {
				this._handleFormChange({ target: readyBtn });
			});
		}

	}

	/**
	 * Настраивает datepicker
	 */
	_setupDatePicker() {
		// Здесь будет логика для обработки выбора даты
		// Пока просто оставим placeholder
		console.log('[Excursions] DatePicker setup - placeholder');
	}

	/**
	 * Обрабатывает изменения в форме фильтров
	 */
	async _handleFormChange(event) {
		try {
			// Создаем компонент если его нет
			if (!this.activeComponent) {
				await this._createComponent();
			}

			// Собираем данные из формы
			const form = event.target.closest('form') || document.querySelector('.excursions__control');
			const formData = new FormData(form);
			const filterData = Object.fromEntries(formData.entries());

			console.log('[Excursions] Form changed with data:', filterData);

			// Показываем лоадер
			this._showLoader();

			// Делаем прямой AJAX запрос на обновление данных
			await this._updateExcursionsData();

		} catch (error) {
			console.error('[Excursions] Error updating excursions list:', error);
		} finally {
			// Скрываем лоадер
			this._hideLoader();
		}
	}

	/**
	 * Получает ID заказа со страницы
	 * @returns {string|null} ID заказа
	 */
	_getOrderId() {
		// Вариант 1: Из скрытого поля #orderId
		const orderIdElement = document.querySelector('#orderId');
		if (orderIdElement && orderIdElement.value) return orderIdElement.value;

		// Вариант 2: Из data-атрибута
		const dataElement = document.querySelector('[data-invoice-id]');
		if (dataElement) {
			const idFromData = dataElement.getAttribute('data-invoice-id');
			if (idFromData) return idFromData;
		}

		// Вариант 3: Из URL
		const urlParams = new URLSearchParams(window.location.search);
		const idFromUrl = urlParams.get('id');
		if (idFromUrl) return idFromUrl;

		return null;
	}

	/**
	 * Обновляет данные экскурсий через AJAX
	 */
	async _updateExcursionsData() {
		try {
			// Используем ServiceManager для получения данных формы
			if (typeof window.serviceManager === 'undefined') {
				console.error('[Excursions] serviceManager is not available');
				throw new Error('ServiceManager not available');
			}

			// Получаем данные через единый метод ServiceManager
			const excursionsData = window.serviceManager.getExcursionsFormData();

			// Создаем FormData
			const formData = new FormData();

			// Добавляем все данные в FormData
			Object.entries(excursionsData).forEach(([key, value]) => {
				if (Array.isArray(value)) {
					value.forEach(item => {
						formData.append(`${key}[]`, item);
					});
				} else {
					formData.append(key, value);
				}
			});

			// Добавляем action
			formData.set('action', 'loadItems');

			// Добавляем orderId если он есть
			if (this.orderId) {
				formData.set('orderId', this.orderId);
				console.log('[Excursions] Adding orderId to request:', this.orderId);
			}

			console.log('[Excursions] Sending AJAX request to update excursions with data:', excursionsData);

			const response = await fetch('/ajax.php?mid=20', {
				method: 'POST',
				body: formData
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const xmlText = await response.text();
			console.log('[Excursions] Received XML response, updating component');

			// Обновляем компонент с новыми данными
			await this.activeComponent.vroc.updateComponent(this.activeComponent.id, xmlText);

			console.log('[Excursions] Excursions list updated successfully');

		} catch (error) {
			console.error('[Excursions] Error in _updateExcursionsData:', error);
			throw error;
		}
	}

	/**
	 * Показывает лоадер
	 */
	_showLoader() {
		const loader = document.querySelector('.excursions__loader');
		if (loader) {
			loader.classList.add('active');
		}
	}

	/**
	 * Скрывает лоадер
	 */
	_hideLoader() {
		const loader = document.querySelector('.excursions__loader');
		if (loader) {
			loader.classList.remove('active');
		}
	}

	/**
	 * Создает компонент для управления экскурсиями
	 * @returns {Promise<VROCComponent>} - Созданный компонент
	 */
	async _createComponent() {
		// Уничтожаем предыдущий активный компонент если он есть
		if (this.activeComponent) {
			console.log('Excursions: Destroying previous component');
			this.activeComponent = null;
		}

		// Создаем новый компонент
		const component = await vrocManager.createComponent('excursions');

		this.activeComponent = component;
		console.log('Excursions: Component created');

		return component;
	}

	/**
	 * Инициализирует компонент (вызывается после загрузки страницы)
	 */
	async init() {
		if (!this.activeComponent) {
			// Показываем лоадер при инициализации
			this._showLoader();
			try {
				await this._createComponent();
			} finally {
				// Скрываем лоадер после инициализации
				this._hideLoader();
			}
		}
	}

	/**
	 * Обновляет список экскурсий с новыми фильтрами
	 */
	async updateExcursionsList(filterData = {}) {
		// Создаем компонент если его нет
		if (!this.activeComponent) {
			await this._createComponent();
		}

		try {
			console.log('[Excursions] Updating excursions list with filters:', filterData);
			this._showLoader();
			await this._updateExcursionsData();
		} catch (error) {
			console.error('[Excursions] Error in updateExcursionsList:', error);
			throw error;
		} finally {
			this._hideLoader();
		}
	}

	/**
	 * Уничтожает активный компонент
	 */
	destroyActiveComponent() {
		if (this.activeComponent) {
			// Находим ID компонента в менеджере и уничтожаем его
			const components = vrocManager.getComponentsByName('excursions');
			const componentToDestroy = components.find(c => c === this.activeComponent);

			if (componentToDestroy) {
				// Получаем ID экземпляра из имени компонента
				const instanceId = componentToDestroy.id;
				vrocManager.destroyComponent(instanceId);
			}

			this.activeComponent = null;
			console.log('Excursions: Active component destroyed');
		}
	}

	destroyAllComponents() {
		vrocManager.destroyComponentsByName('excursions');
		this.activeComponent = null;
		console.log('Excursions: All components destroyed');
	}

	/**
	 * Получает активный компонент
	 * @returns {VROCComponent|null}
	 */
	getActiveComponent() {
		return this.activeComponent;
	}

	/**
	 * Публичный метод для обновления компонента (вызывается из app.js)
	 */
	async update() {
		try {
			console.log('[Excursions] Public update called');

			// Создаем компонент если его нет
			if (!this.activeComponent) {
				await this._createComponent();
			}

			// Показываем лоадер
			this._showLoader();

			// Обновляем данные
			await this._updateExcursionsData();

		} catch (error) {
			console.error('[Excursions] Error in public update:', error);
		} finally {
			// Скрываем лоадер
			this._hideLoader();
		}
	}

	// ===== МЕТОДЫ УПРАВЛЕНИЯ ТЕГАМИ ФИЛЬТРОВ =====

	/**
	 * Инициализирует обработчики для фильтров
	 */
	setupFilters() {
		// Находим попап с фильтрами
		const filtersPopup = document.querySelector('.popup[data-popup-name="excursions-filters"]');
		if (!filtersPopup) return;

		// Добавляем обработчики на чекбоксы фильтров
		const filterCheckboxes = filtersPopup.querySelectorAll('input[type="checkbox"]');
		filterCheckboxes.forEach(checkbox => {
			checkbox.addEventListener('change', (e) => {
				this._handleFilterChange(e.target);
			});
		});

		// Настраиваем кнопку "Сбросить всё"
		const resetAllBtn = document.querySelector('.excursions-filters-controls__reset');
		if (resetAllBtn) {
			resetAllBtn.addEventListener('click', () => {
				this.resetFilters();
			});
		}

		console.log('[Excursions] Filters setup completed');
	}

	/**
	 * Обрабатывает изменение фильтра (добавление/удаление тега)
	 */
	_handleFilterChange(checkbox) {
		if (checkbox.checked) {
			this._addFilterTag(checkbox);
		} else {
			this._removeFilterTag(checkbox);
		}

		// Обновляем видимость кнопки "Сбросить всё"
		this._updateResetAllButton();
	}

	/**
	 * Добавляет тег активного фильтра
	 */
	_addFilterTag(checkbox) {
		const template = document.getElementById('filter-tag-template-excursions');
		if (!template) {
			console.error('[Excursions] Filter tag template not found');
			return;
		}

		const tagsList = document.querySelector('.excursions-filters-controls__choiced-list');
		if (!tagsList) {
			console.error('[Excursions] Filter tags list not found');
			return;
		}

		// Клонируем шаблон
		const clone = template.content.cloneNode(true);
		const li = clone.querySelector('li');
		const btn = clone.querySelector('button');
		const caption = clone.querySelector('.excursions-filters-controls__choiced-caption');

		// Получаем текст фильтра из label
		const label = document.querySelector(`label[for="${checkbox.id}"]`);
		let filterText = checkbox.value;

		if (label) {
			// Извлекаем только текст названия фильтра, без счётчика
			const titleElement = label.querySelector('.service-filters__item-title');
			if (titleElement) {
				// Берем только текстовое содержимое, исключая вложенные элементы
				filterText = titleElement.childNodes[0]?.textContent?.trim() || checkbox.value;
			}
		}

		caption.textContent = filterText;

		// Сохраняем ID чекбокса в data-атрибуте
		li.setAttribute('data-filter-id', checkbox.id);

		// Добавляем обработчик на кнопку удаления
		btn.addEventListener('click', () => {
			this._removeFilterTagByElement(li, checkbox);
		});

		// Добавляем в список
		tagsList.appendChild(clone);

		console.log('[Excursions] Filter tag added:', filterText);
	}

	/**
	 * Удаляет тег фильтра
	 */
	_removeFilterTag(checkbox) {
		const tag = document.querySelector(`li[data-filter-id="${checkbox.id}"]`);
		if (tag) {
			tag.remove();
			console.log('[Excursions] Filter tag removed');
		}
	}

	/**
	 * Удаляет тег фильтра по элементу и снимает чекбокс
	 */
	async _removeFilterTagByElement(tagElement, checkbox) {
		// Снимаем чекбокс
		checkbox.checked = false;

		// Удаляем тег
		tagElement.remove();

		// Обновляем видимость кнопки "Сбросить всё"
		this._updateResetAllButton();

		// Обновляем список экскурсий
		await this._handleFormChange({ target: checkbox });

		console.log('[Excursions] Filter removed and excursions list updated');
	}

	/**
	 * Обновляет видимость кнопки "Сбросить всё"
	 */
	_updateResetAllButton() {
		const resetAllBtn = document.querySelector('.excursions-filters-controls__reset');
		if (!resetAllBtn) return;

		const tagsList = document.querySelector('.excursions-filters-controls__choiced-list');
		const hasTags = tagsList && tagsList.children.length > 0;

		resetAllBtn.style.display = hasTags ? 'flex' : 'none';
	}

	/**
	 * Очищает все теги фильтров
	 */
	_clearAllFilterTags() {
		const tagsList = document.querySelector('.excursions-filters-controls__choiced-list');
		if (tagsList) {
			tagsList.innerHTML = '';
		}

		// Обновляем видимость кнопки "Сбросить всё"
		this._updateResetAllButton();
	}

	/**
	 * Синхронизирует теги с состоянием чекбоксов (вызывается при инициализации)
	 */
	syncFilterTags() {
		// Очищаем все теги
		this._clearAllFilterTags();

		// Находим все отмеченные чекбоксы и создаем для них теги
		const filtersPopup = document.querySelector('.popup[data-popup-name="excursions-filters"]');
		if (filtersPopup) {
			const checkedFilters = filtersPopup.querySelectorAll('input[type="checkbox"]:checked');
			checkedFilters.forEach(checkbox => {
				this._addFilterTag(checkbox);
			});
		}

		// Обновляем видимость кнопки "Сбросить всё"
		this._updateResetAllButton();

		console.log('[Excursions] Filter tags synced');
	}

	/**
	 * Применяет фильтры и закрывает попап
	 */
	applyFilters() {
		// Закрываем попап через PopupManager
		if (typeof window.popupManager !== 'undefined') {
			window.popupManager.close('excursions-filters');
		}
		console.log('[Excursions] Filters applied');
	}

	/**
	 * Сбрасывает все фильтры и закрывает попап
	 */
	async resetFilters() {
		// Находим попап с фильтрами
		const filtersPopup = document.querySelector('.popup[data-popup-name="excursions-filters"]');

		if (filtersPopup) {
			// Сбрасываем все чекбоксы
			const checkboxes = filtersPopup.querySelectorAll('input[type="checkbox"]');
			checkboxes.forEach(checkbox => {
				checkbox.checked = false;
			});

			// Сбрасываем все текстовые поля, если есть
			const inputs = filtersPopup.querySelectorAll('input[type="text"], input[type="number"]');
			inputs.forEach(input => {
				input.value = '';
			});

			// Сбрасываем все селекты, если есть
			const selects = filtersPopup.querySelectorAll('select');
			selects.forEach(select => {
				select.selectedIndex = 0;
			});

			console.log('[Excursions] Filters reset');
		}

		// Очищаем все теги фильтров
		this._clearAllFilterTags();

		// Закрываем попап через PopupManager
		if (typeof window.popupManager !== 'undefined') {
			window.popupManager.close('excursions-filters');
		}

		// Обновляем список экскурсий с учетом сброшенных фильтров
		await this.update();
	}
}
